/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */

export default {
	'Type something': 'Ketik sesuatu',
	'About Jodit': 'Tentang Jodit',
	'Jodit Editor': 'Editor Jodit',
	'Free Non-commercial Version': 'Versi Bebas Non-komersil',
	"Jodit User's Guide": 'Panduan Pengguna Jodit',
	'contains detailed help for using': 'mencakup detail bantuan penggunaan',
	'For information about the license, please go to our website:':
		'Untuk informasi tentang lisensi, silakan kunjungi website:',
	'Buy full version': 'Beli versi lengkap',
	'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.':
		'Hak Cipta © XDSoft.net - Chupurnov Valeriy. Hak cipta dilindungi undang-undang.',
	Anchor: 'Tautan',
	'Open in new tab': 'Buka di tab baru',
	'Open in fullsize': 'Buka editor dalam ukuran penuh',
	'Clear Formatting': 'Hapus Pemformatan',
	'Fill color or set the text color': 'Isi warna atau atur warna teks',
	Redo: 'Ulangi',
	Undo: 'Batalkan',
	Bold: 'Tebal',
	Italic: 'Miring',
	'Insert Unordered List': 'Sisipkan Daftar Tidak Berurut',
	'Insert Ordered List': 'Sisipkan Daftar Berurut',
	'Align Center': 'Tengah',
	'Align Justify': 'Penuh',
	'Align Left': 'Kiri',
	'Align Right': 'Kanan',
	'Insert Horizontal Line': 'Sisipkan Garis Horizontal',
	'Insert Image': 'Sisipkan Gambar',
	'Insert file': 'Sisipkan Berkas',
	'Insert youtube/vimeo video': 'Sisipkan video youtube/vimeo',
	'Insert link': 'Sisipkan tautan',
	'Font size': 'Ukuran font',
	'Font family': 'Keluarga font',
	'Insert format block': 'Sisipkan blok format',
	Normal: 'Normal',
	'Heading 1': 'Heading 1',
	'Heading 2': 'Heading 2',
	'Heading 3': 'Heading 3',
	'Heading 4': 'Heading 4',
	Quote: 'Kutip',
	Code: 'Kode',
	Insert: 'Sisipkan',
	'Insert table': 'Sisipkan tabel',
	'Decrease Indent': 'Kurangi Indentasi',
	'Increase Indent': 'Tambah Indentasi',
	'Select Special Character': 'Pilih Karakter Spesial',
	'Insert Special Character': 'Sisipkan Karakter Spesial',
	'Paint format': 'Formar warna',
	'Change mode': 'Ubah mode',
	Margins: 'Batas',
	top: 'atas',
	right: 'kanan',
	bottom: 'bawah',
	left: 'kiri',
	Styles: 'Gaya',
	Classes: 'Class',
	Align: 'Rata',
	Right: 'Kanan',
	Center: 'Tengah',
	Left: 'Kiri',
	'--Not Set--': '--Tidak diset--',
	Src: 'Src',
	Title: 'Judul',
	Alternative: 'Teks alternatif',
	Link: 'Tautan',
	'Open link in new tab': 'Buka tautan di tab baru',
	Image: 'Gambar',
	file: 'berkas',
	Advanced: 'Lanjutan',
	'Image properties': 'Properti gambar',
	Cancel: 'Batal',
	Ok: 'Ya',
	'Your code is similar to HTML. Keep as HTML?':
		'Kode Anda cenderung ke HTML. Biarkan sebagai HTML?',
	'Paste as HTML': 'Paste sebagai HTML',
	Keep: 'Jaga',
	Clean: 'Bersih',
	'Insert as Text': 'Sisipkan sebagai teks',
	'Insert only Text': 'Sisipkan hanya teks',
	'Word Paste Detected': 'Terdeteksi paste dari Word',
	'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?':
		'Konten dipaste dari dokumen Microsoft Word/Excel. Apakah Anda ingin tetap menjaga format atau membersihkannya?',
	'File Browser': 'Penjelajah Berkas',
	'Error on load list': 'Error ketika memuat list',
	'Error on load folders': 'Error ketika memuat folder',
	'Are you sure?': 'Apakah Anda yakin?',
	'Enter Directory name': 'Masukkan nama Direktori',
	'Create directory': 'Buat direktori',
	'type name': 'ketik nama',
	'Drop image': 'Letakkan gambar',
	'Drop file': 'Letakkan berkas',
	'or click': 'atau klik',
	'Alternative text': 'Teks alternatif',
	Browse: 'Jelajahi',
	Upload: 'Unggah',
	Background: 'Latar Belakang',
	Text: 'Teks',
	Top: 'Atas',
	Middle: 'Tengah',
	Bottom: 'Bawah',
	'Insert column before': 'Sisipkan kolom sebelumnya',
	'Insert column after': 'Sisipkan kolom setelahnya',
	'Insert row above': 'Sisipkan baris di atasnya',
	'Insert row below': 'Sisipkan baris di bawahnya',
	'Delete table': 'Hapus tabel',
	'Delete row': 'Hapus baris',
	'Delete column': 'Hapus kolom',
	'Empty cell': 'Kosongkan cell',
	source: 'sumber',
	bold: 'tebal',
	italic: 'miring',
	brush: 'sikat',
	link: 'tautan',
	undo: 'batalkan',
	redo: 'ulangi',
	table: 'tabel',
	image: 'gambar',
	eraser: 'penghapus',
	paragraph: 'paragraf',
	fontsize: 'ukuran font',
	video: 'video',
	font: 'font',
	about: 'tentang',
	print: 'cetak',
	underline: 'garis bawah',
	strikethrough: 'coret',
	indent: 'menjorok ke dalam',
	outdent: 'menjorok ke luar',
	fullsize: 'ukuran penuh',
	shrink: 'menyusut',
	hr: 'hr',
	ul: 'ul',
	ol: 'ol',
	cut: 'potong',
	selectall: 'Pilih semua',
	'Embed code': 'Kode embed',
	'Open link': 'Buka tautan',
	'Edit link': 'Edit tautan',
	'No follow': 'No follow',
	Unlink: 'Hapus tautan',
	Eye: 'Mata',
	pencil: 'pensil',
	Update: 'Perbarui',
	' URL': 'URL',
	Edit: 'Edit',
	'Horizontal align': 'Perataan horizontal',
	Filter: 'Filter',
	'Sort by changed': 'Urutkan berdasarkan perubahan',
	'Sort by name': 'Urutkan berdasarkan nama',
	'Sort by size': 'Urutkan berdasarkan ukuran',
	'Add folder': 'Tambah folder',
	Reset: 'Reset',
	Save: 'Simpan',
	'Save as ...': 'Simpan sebagai...',
	Resize: 'Ubah ukuran',
	Crop: 'Crop',
	Width: 'Lebar',
	Height: 'Tinggi',
	'Keep Aspect Ratio': 'Jaga aspek rasio',
	Yes: 'Ya',
	No: 'Tidak',
	Remove: 'Copot',
	Select: 'Pilih',
	'Chars: %d': 'Karakter: %d',
	'Words: %d': 'Kata: %d',
	All: 'Semua',
	'Select %s': 'Pilih %s',
	'Select all': 'Pilih semua',
	'Vertical align': 'Rata vertikal',
	Split: 'Bagi',
	'Split vertical': 'Bagi secara vertikal',
	'Split horizontal': 'Bagi secara horizontal',
	Merge: 'Gabungkan',
	'Add column': 'Tambah kolom',
	'Add row': 'tambah baris',
	Delete: 'Hapus',
	Border: 'Bingkai',
	'License: %s': 'Lisensi: %s',
	'Strike through': 'Coret',
	Underline: 'Garis Bawah',
	superscript: 'Superskrip',
	subscript: 'Subskrip',
	'Cut selection': 'Potong pilihan',
	Break: 'Berhenti',
	'Search for': 'Mencari',
	'Replace with': 'Ganti dengan',
	Replace: 'Mengganti',
	Paste: 'Paste',
	'Choose Content to Paste': 'Pilih konten untuk dipaste',
	'You can only edit your own images. Download this image on the host?':
		'Anda hanya dapat mengedit gambar Anda sendiri. Unduh gambar ini di host?',
	'The image has been successfully uploaded to the host!':
		'Gambar telah sukses diunggah ke host!',
	palette: 'palet',
	'There are no files': 'Tidak ada berkas',
	Rename: 'ganti nama',
	'Enter new name': 'Masukkan nama baru',
	preview: 'pratinjau',
	download: 'Unduh',
	'Paste from clipboard': 'Paste dari clipboard',
	"Your browser doesn't support direct access to the clipboard.":
		'Browser anda tidak mendukung akses langsung ke clipboard.',
	'Copy selection': 'Copy seleksi',
	copy: 'copy',
	'Border radius': 'Border radius',
	'Show all': 'Tampilkan semua',
	Apply: 'Menerapkan',
	'Please fill out this field': 'Silahkan mengisi kolom ini',
	'Please enter a web address': 'Silahkan masukkan alamat web',
	Default: 'Default',
	Circle: 'Lingkaran',
	Dot: 'Dot',
	Quadrate: 'Kuadrat',
	Find: 'Menemukan',
	'Find Previous': 'Menemukan Sebelumnya',
	'Find Next': 'Menemukan Berikutnya',
	'Insert className': 'Masukkan nama kelas',
	'Press Alt for custom resizing': 'Tekan Alt untuk mengubah ukuran kustom'
};
